import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useCreateTemplate = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("/DocumentType/CreateDocumentType", formData);
  });
  return mutation;
};
export default useCreateTemplate;
